module.exports = __webpack_public_path__ + "img/cross-icon.9c3256c1.svg";